import React, { FC } from 'react';
import { Box, SvgIcon, useTheme } from '@mui/material';
import styles from './HeaderComponent.module.scss';
import BoddLogo from '../../assets/logos/bodd-black.svg';
import RiyadhAirLogo from '../../assets/logos/riyadh-air.svg';
import PortwestLogo from '../../assets/logos/portwest.svg';
import TowerLogo from '../../assets/logos/tower.svg';
import CooneenLogo from '../../assets/logos/cooneen.svg';
import NugentLogo from '../../assets/logos/nugent.svg';
import LeidosLogo from '../../assets/logos/leidos.svg';
import StLogisticsLogo from '../../assets/logos/st-logistics.svg';
import BritishAirwaysLogo from '../../assets/logos/british-airways.svg';
import GardaLogo from '../../assets/logos/garda.svg';
import EmiratesLogo from '../../assets/logos/emirates.svg';
import boddTheme, {
    riyadhAirTheme,
    portwestTheme,
    towerTheme,
    cooneenTheme,
    nugentTheme,
    leidosTheme,
    boddDemoTheme,
    stLogisticsTheme,
    britishAirwaysTheme,
    gardaTheme, emiratesTheme,
} from '../../theme/theme';

interface HeaderComponentProps {
}

const HeaderComponent: FC<HeaderComponentProps> = () => {
    const theme = useTheme();

    return (
        <div className={styles.HeaderComponent} data-testid="HeaderComponent">
            {theme === boddTheme && (
                <>
                    <Box className={styles.ColourBar} sx={{ height: 5, mb: 4.25 }} />
                    <SvgIcon sx={{ width: '74px', height: '60px' }}><BoddLogo /></SvgIcon>
                </>
            )}
            {theme === boddDemoTheme && (
                <>
                    <Box className={styles.ColourBar} sx={{ height: 5, mb: 4.25 }} />
                    <SvgIcon sx={{ width: '74px', height: '60px' }}><BoddLogo /></SvgIcon>
                </>
            )}
            {theme === riyadhAirTheme && (
                <Box sx={{ bgcolor: theme.palette.primary.main, pt: '16px', pb: '12px' }}>
                    <SvgIcon viewBox="0 0 173 60" sx={{ width: '173px', height: '60px', color: 'white' }}><RiyadhAirLogo /></SvgIcon>
                </Box>
            )}
            {theme === portwestTheme && (
                <Box sx={{ bgcolor: theme.palette.primary.main, pt: '17px', pb: '24px' }}>
                    <SvgIcon viewBox="0 0 173 60" sx={{ width: '189px', height: '47px', color: 'white' }}><PortwestLogo /></SvgIcon>
                </Box>
            )}
            {theme === towerTheme && (
                <Box sx={{ bgcolor: theme.palette.primary.main, py: '16px' }}>
                    <SvgIcon viewBox="0 0 794 233" sx={{ width: '190px', height: '56px' }}><TowerLogo /></SvgIcon>
                </Box>
            )}
            {theme === cooneenTheme && (
                <Box sx={{ bgcolor: theme.palette.primary.main, py: '16px' }}>
                    <SvgIcon viewBox="0 0 813.6 98.2" sx={{ width: '203.4px', height: '24.55px' }}><CooneenLogo /></SvgIcon>
                </Box>
            )}
            {theme === nugentTheme && (
                <Box sx={{ bgcolor: theme.palette.primary.main, py: '16px' }}>
                    <SvgIcon viewBox="0 0 889 153" sx={{ width: '222.25px', height: '38.25px' }}><NugentLogo /></SvgIcon>
                </Box>
            )}
            {theme === leidosTheme && (
                <Box sx={{ bgcolor: theme.palette.primary.main, py: '16px', pr: '24px' }}>
                    <SvgIcon viewBox="0 0 867 204" sx={{ width: '216.75px', height: '51px' }}><LeidosLogo /></SvgIcon>
                </Box>
            )}
            {theme === stLogisticsTheme && (
                <Box sx={{ bgcolor: theme.palette.primary.main, py: '16px' }}>
                    <SvgIcon viewBox="0 0 984 141" sx={{ width: '328px', height: '47px' }}><StLogisticsLogo /></SvgIcon>
                </Box>
            )}
            {theme === britishAirwaysTheme && (
                <Box sx={{ bgcolor: theme.palette.primary.main, py: '16px' }}>
                    <SvgIcon viewBox="0 0 968 151" sx={{ width: '242px', height: '38px' }}><BritishAirwaysLogo /></SvgIcon>
                </Box>
            )}
            {theme === gardaTheme && (
                <Box sx={{ bgcolor: theme.palette.primary.main, py: '16px' }}>
                    <SvgIcon viewBox="0 0 968 151" sx={{ width: '272px', height: '58px' }}><GardaLogo /></SvgIcon>
                </Box>
            )}
            {theme === emiratesTheme && (
                <Box sx={{ bgcolor: theme.palette.primary.main, py: '16px' }}>
                    <SvgIcon viewBox="0 0 177 59" sx={{ width: '177px', height: '59px' }}><EmiratesLogo /></SvgIcon>
                </Box>
            )}
        </div>
    );
};

export default HeaderComponent;
